import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const s = "review_auto_tag_settings";
class g extends n {
  async getAutoTagSettings() {
    const { data: t } = await this.get(s);
    return t;
  }
  async updateAutoTagSettings(t, a) {
    const { data: e } = await this.put(
      `${s}/${t}`,
      a
    );
    return e;
  }
  async postAutoTagSettings(t) {
    const { data: a } = await this.post(s, t);
    return a;
  }
}
export {
  g as ReviewAutoTagSettings
};
